import { Close, Download, School } from "@mui/icons-material";
import API from "../../../services/API";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { Avatar, Checkbox, FormControlLabel, Paper, Stack, Typography } from "@mui/material";
import moment from "moment";

export default function StudentProof({ person }) {

    const [status, setStatus] = useState('ready');

    const [verifiedAt, setVerifiedAt] = useState(null);

    useEffect(() => {
        setVerifiedAt(person?.proofVerifiedAt);
    }, [person])

    if (person?.status?.id !== 'etudiant') return false;

    const handleClick = () => {
        setStatus('pending');

        API.download(`/crm/users/${person.id}/student-proof`)
            .then(() => setStatus('ready'))
            .catch(() => setStatus('error'));
    }

    const handleToggle = () => {
        const oldVerifiedAt = verifiedAt;
        const newVerifiedAt = verifiedAt ? null : moment().toISOString();
        console.log(newVerifiedAt);
        const newPerson = { ...person, proofVerifiedAt: newVerifiedAt };
        API.put(`/crm/users/${person.id}`, newPerson)
            .then(r => console.log(r.data))
            .catch(_ => setVerifiedAt(oldVerifiedAt))
        setVerifiedAt(newVerifiedAt);
    }

    return (
            <Paper variant="outlined" sx={{ p: 1.5, width: 'fit-content' }}>
                <Stack direction="row" flexWrap="wrap" spacing={1}>

                    <Avatar>
                        <School />
                    </Avatar>

                    <LoadingButton 
                        endIcon={status === 'error' ? <Close /> : <Download />}
                        onClick={handleClick}
                        loading={status === 'pending'}
                        disabled={status === 'error'}
                    >
                        {status === 'error' ? 'Justificatif introuvable' : 'Justificatif étudiant'}
                    </LoadingButton>

                    <FormControlLabel 
                        control={
                            <Checkbox
                                checked={!!verifiedAt} 
                                onChange={handleToggle}
                                color="success"
                                size="small"
                            />
                        } 
                        label={
                            <Typography color="text.secondary" variant="body2">
                                Justificatif vérifié {verifiedAt ? `le ${moment(verifiedAt).format('DD/MM/YYYY')}` : ''}
                            </Typography>
                        }
                    />

                </Stack>
            </Paper>
    );
}